import apolloClient from "../graphql";
import { CHECKIN_REQUIREMENTS, CHECKIN_REQUIREMENTS_SEGMENT_LEVEL } from "../graphql/checkinQueries";

export async function CheckInRequirements(journeyKey: string) {
  const response = await apolloClient.query({
    query: CHECKIN_REQUIREMENTS,
    variables: {
      journeyKey: `${journeyKey}`
    }
  });
  return response;
}

export async function CheckInRequirementsSegmentLevel(segmentKey: string) {
  const response = await apolloClient.query({
    query: CHECKIN_REQUIREMENTS_SEGMENT_LEVEL,
    variables: {
      segKey: `${segmentKey}`
    }
  });
  const { restrictions } = response.data?.checkinBySegmentRequirements;
  const hasRestrictions = restrictions !== null;
  return { restrictionStatus: hasRestrictions, ...response.data };
}
